import { Children } from "react";
import { MaterialesSomacylDTO, SomacylOrderENTITY } from "sigo-entities";
import { AdapterGenerico } from "../../shared/Infraestructure/AdapterGenerico";
import { Spinner } from "react-bootstrap";

interface Props {
    row: SomacylOrderENTITY
    deleteInventory: (id: string, codigo: number, serie: string) => Promise<void>
    isLoading: boolean
}

export function TableInventory(props: Props) {
    const { row, deleteInventory, isLoading } = props

    const onDeleteMaterial = async (e: MaterialesSomacylDTO) => {
        try {
            await deleteInventory(row._id, e.ID_Stock, e.invsn)
            AdapterGenerico.createMessage('Información', 'Eliminado!', 'success')
        } catch (error) {
            console.error(error)
            AdapterGenerico.createMessage('Alerta', (error as Error).message, 'error')
        }
    }

    return (
        <table
            className='table table-striped'
            style={{
                backgroundColor: 'gray',
                display: row.inventory.length > 0 ? undefined : 'none'
            }}
        >
            <thead>
                <tr>
                    <th scope='col'>Código</th>
                    <th scope='col'>Descripción</th>
                    <th scope='col' className='text-center'>Cantidad</th>
                    <th scope='col' className='text-center'>Serie</th>
                    <th scope='col' className='text-center'>Tipo</th>
                    <th scope='col' style={{ textAlign: 'center' }}>x</th>
                </tr>
            </thead>
            <tbody>
                {
                    Children.toArray(
                        row.inventory.map(e =>
                            <tr>
                                <td>{e.codigo}</td>
                                <td>{e.descripcion}</td>
                                <td className='text-center'>{e.cantidad.toFixed(2)}</td>
                                <td className='text-center'>{e.invsn}</td>
                                <td className='text-center'>{e.invpool}</td>
                                <td
                                    scope='row'
                                    onClick={() => onDeleteMaterial(e)}
                                    style={{ verticalAlign: 'middle', textAlign: 'center' }}
                                >
                                    {
                                        isLoading ? (
                                            <Spinner animation='border' size='sm' />
                                        ) : (
                                            <i className='fa-solid fa-trash' style={{ fontSize: 15, color: 'red' }} />
                                        )
                                    }
                                </td>
                            </tr>
                        )
                    )
                }
            </tbody>
        </table>
    )
}